// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { equipmentId } from './Equipment';
import { operatorId } from './Operator';
import { z } from 'zod';
export const deviceEquipmentBindingId = (z.number());
export const deviceEquipmentBinding = z.object({
    id: deviceEquipmentBindingId,
    device_id: deviceId,
    equipment_id: equipmentId,
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const deviceEquipmentBindingInitializer = z.object({
    id: deviceEquipmentBindingId.optional(),
    device_id: deviceId,
    equipment_id: equipmentId,
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const deviceEquipmentBindingMutator = z.object({
    id: deviceEquipmentBindingId.optional(),
    device_id: deviceId.optional(),
    equipment_id: equipmentId.optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=DeviceEquipmentBinding.js.map